<template>
  <div class="pie">
    <div v-resize="resizeChart" :id="commonRingId" class="commonRingItems" :style="{width: width, height: height}" ></div>
  </div>
</template>

<script>
import {debounce} from "../../../../utils/util";

export default {
  name: 'common-ring',
  props: {
    commonRingId: {
      type: String,
      default () {
        return 'commonRingId'
      }
    },
    width: {
      type: String,
      default () {
        return '100%'
      }
    },
    height: {
      type: String,
      default () {
        return '220px'
      }
    },
    ringTitleLeft: {
      type: String,
      default () {
        return 'center'
      }
    },
    ringTitle: {
      type: String,
      default () {
        return ''
      }
    },
    ringLegend: {
      type: Object,
      default () {
        return {
          left: 'center',
          bottom: 5,
        }
      }
    },
    colorList: {
      type: Array,
      default () {
        return ['#5B9BD5', '#ED7D31', '#FFC000', '#A5A5A5', '#C2A753', '#4BB66E', '#FFA336', '#53A5BC']
      }
    },
    ringData: {
      type: Array,
      default () {
        return []
      }
    },
    ringRadius: {
      type: Array,
      default () {
        return ['40%', '60%']
      }
    },
    ringCenter:  {
      type: Array,
      default () {
        return ['50%', '50%']
      }
    },
    tooltipShow: {
      type: Boolean,
      default: true
    },
    isEmphasis: {
      type: Boolean,
      default: true
    },
    isHoverAnimation: {
      type: Boolean,
      default: true
    },
    seriesItemStyle: {
      type: Object,
      default () {
        return  {
          emphasis: {
            shadowBlur: 10,
            shadowOffsetX: 0,
            shadowColor: 'rgba(0, 0, 0, 0.5)'
          }
        }
      }
    },
  },
  data () {
    return {
      commonRingItems: null
    }
  },
  created () {},
  mounted () {
    this.drawPie()
    window.addEventListener('resize', this.resizeChart)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.resizeChart)
  },
  directives:{
    resize: { // 指令的名称
      bind(el, binding) { // el为绑定的元素，binding为绑定给指令的对象
        console.log(el,"绑定",binding);
        let width = '', height = '';
        function isReize() {
          const style = document.defaultView.getComputedStyle(el);
          if (width !== style.width || height !== style.height) {
            binding.value({width:style.width,height:style.height});  // 关键(这传入的是函数,所以执行此函数)
          }
          width = style.width;
          height = style.height;
        }
        el.__vueSetInterval__ = setInterval(isReize, 300);
      },
      unbind(el) {
        console.log(el,"解绑");
        clearInterval(el.__vueSetInterval__);
      }
    }
  },
  methods: {
    drawPie () {
      this.commonRingItems = this.$echarts.init(document.getElementById(this.commonRingId))
      let percentList = [];
      this.commonRingItems.setOption({
        title : {
          text: this.ringTitle,
          trigger: 'item',
          left: this.ringTitleLeft,
          formatter: '{a} <br/>{b}: {c} ({d}%)',
          titleStyle: {
            color: '#333333'
          }
        },
        tooltip : {
          show: this.tooltipShow,
          trigger: 'item',
          // formatter (data) {
          //   return `${data.name}:${data.value}`
          // },
          formatter: `{b} : {c} ({d}%)`,
          position: ['50%', '50%']
        },
        legend: this.ringLegend,
        color: this.colorList,
        series : [
          {
            name: '',
            type: 'pie',
            radius: this.ringRadius,
            center: this.ringCenter,
            data: this.ringData,
            hoverAnimation: this.isHoverAnimation,
            label: {
              normal: {
                show: true,
                formatter (data) {
                  // console.log(data, 'padata');
                  percentList.push(data.percent);
                  return '';
                },
              },
              emphasis: {
                show: this.isEmphasis,
                textStyle: {
                  fontSize: '12',
                }
              }
            },
            labelLine: {
              normal: {
                show: false
              }
            },
            itemStyle: this.seriesItemStyle
          }
        ]
      });
      // console.log(percentList, 'percentList')
      this.$emit('getPercentList', percentList)
    },

    resizeChart: debounce(function () {
      this.commonMeter.resize()
    }, 100),

    // 跳转防疫登记页面
    toEpidemicSituationRegisterPage (data) {
      this.$router.push({
        path: `/epidemic_situation_register/${data}`
      })
    },

    // 跳转体温监测页面
    toTemperaturePage (data) {
      this.$router.push({
        path: `/temperature/${data}`
      })
    }
  },
  watch: {
    ringData () {
      this.drawPie()
    }
  }
}
</script>

<style scoped lang="less">
.pie {
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.pie-right {
  width: 50%;
  display: flex;
  justify-content: center;
  flex-direction: column;
}
.pie-percentage {
  display: flex;
  justify-content: flex-start;
}
.pie-return {
  margin-bottom: 10px;
}
.hubei:hover {
  cursor: pointer;
  color: #5B9BD5;
}
.wenzhou:hover {
  cursor: pointer;
  color: #ED7D31;
}
.taizhou:hover {
  cursor: pointer;
  color: #FFC000;
}
.ningbo:hover {
  cursor: pointer;
  color: #A5A5A5;
}
</style>



// WEBPACK FOOTER //
// src/components/Echarts/Pie/Pie/commonRing.vue